export default __webpack_public_path__ + "static/media/Palco (1).5a1dd4a5.jpg";